import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const DeviceWirelessGlyph = /*#__PURE__*/createElement("g", {
  id: "device_wireless"
}, /*#__PURE__*/createElement("path", {
  d: "M42.5,31.2c8.4,0,16.1,3.1,21.9,8.3l4.1-4.6c-7-6.1-16-10.4-26-10.4c-10,0-19,4.3-26,10.4l4.1,4.6 C26.4,34.3,34.1,31.2,42.5,31.2z"
}), /*#__PURE__*/createElement("path", {
  d: "M42.5,44.4c5,0,9.6,1.8,13.2,4.9l4.3-4.8c-4.7-4.1-10.8-6.8-17.5-6.8c-6.7,0-12.8,2.7-17.5,6.7l4.3,4.8 C32.9,46.2,37.5,44.4,42.5,44.4z"
}), /*#__PURE__*/createElement("path", {
  d: "M51.4,54.1c-2.4-2-5.5-3.4-8.9-3.4c-3.4,0-6.5,1.4-8.9,3.4l8.9,9.9L51.4,54.1z"
}));
const DeviceWireless = createSvg({
  name: 'device_wireless',
  path: DeviceWirelessGlyph
});

export default DeviceWireless;
export { DeviceWirelessGlyph };
